module.exports = __webpack_public_path__ + "assets/img/companyicon5.97be62b1.jpg";